(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  
  // Animated counter for stats
  function animateCounter(element) {
    const target = parseInt(element.getAttribute('data-count'));
    const duration = 2000;
    const increment = target / (duration / 16);
    let current = 0;
    
    const timer = setInterval(function() {
      current += increment;
      if (current >= target) {
        element.textContent = target;
        clearInterval(timer);
      } else {
        element.textContent = Math.floor(current);
      }
    }, 16);
  }
  
  // Intersection Observer for stats
  const statsObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        const statNumbers = entry.target.querySelectorAll('.about-page__stat-number');
        statNumbers.forEach(function(stat) {
          if (!stat.classList.contains('animated')) {
            stat.classList.add('animated');
            animateCounter(stat);
          }
        });
        statsObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.5
  });
  
  // Observe all stats blocks
  const statsBlocks = document.querySelectorAll('.about-page__stats-block');
  statsBlocks.forEach(function(block) {
    statsObserver.observe(block);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Discount code copy function
    function copyDiscountCode(e) {
      e.preventDefault();
      const btn = e.currentTarget;
      const code = btn.dataset.code.trim();
      
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function() {
          btn.classList.add('success');
          setTimeout(function() {
            btn.classList.remove('success');
          }, 2000);
        });
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = code;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          btn.classList.add('success');
          setTimeout(function() {
            btn.classList.remove('success');
          }, 2000);
        } catch (err) {
          console.error('Kopyalama hatası:', err);
        }
        document.body.removeChild(textArea);
      }
    }

    // Make function globally available
    window.copyDiscountCode = copyDiscountCode;

    // Announcement bar marquee animation speed
    function initAnnouncementMarquee() {
      const marqueeBars = document.querySelectorAll('.announcement-bar--marquee');
      
      marqueeBars.forEach(function(bar) {
        const track = bar.querySelector('.announcement-bar__marquee-track');
        if (!track) return;

        const speed = parseFloat(bar.getAttribute('data-speed')) || 10;
        const items = track.querySelectorAll('.announcement-bar__marquee-item');
        
        if (items.length === 0) return;

        // Calculate total width of first set (half of all items)
        let totalWidth = 0;
        const firstSetCount = Math.floor(items.length / 2);
        for (let i = 0; i < firstSetCount; i++) {
          const item = items[i];
          const itemWidth = item.offsetWidth;
          totalWidth += itemWidth;
        }

        // Set animation duration based on speed and width
        // Speed is in seconds per viewport width
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        const duration = (totalWidth / viewportWidth) * speed;
        
        track.style.animationDuration = duration + 's';
        track.style.animationName = 'announcement-marquee';
        track.style.animationTimingFunction = 'linear';
        track.style.animationIterationCount = 'infinite';
      });
    }

    // Initialize on DOM ready
    function initializeMarquee() {
      setTimeout(function() {
        initAnnouncementMarquee();
      }, 100);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeMarquee);
    } else {
      initializeMarquee();
    }

    // Re-initialize on section load (for theme editor)
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(e) {
        if (e.detail.sectionId && document.querySelector('.announcement-bar[data-section-id="' + e.detail.sectionId + '"]')) {
          initializeMarquee();
        }
      });
    }

    // Also try after a short delay to ensure DOM is ready
    window.addEventListener('load', function() {
      setTimeout(initAnnouncementMarquee, 200);
    });

    // Update on resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        initAnnouncementMarquee();
      }, 200);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    const quantityButtons = document.querySelectorAll('.cart-page__quantity-btn');
    const quantityInputs = document.querySelectorAll('.cart-page__quantity-input');
    
    quantityButtons.forEach(button => {
      button.addEventListener('click', function() {
        const action = this.dataset.action;
        const line = this.dataset.line;
        const input = document.getElementById('quantity-' + line);
        
        if (!input) return;
        
        let value = parseInt(input.value) || 0;
        
        if (action === 'increase') {
          value += 1;
        } else if (action === 'decrease' && value > 1) {
          value -= 1;
        }
        
        input.value = value;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var lightsKey = 'arcela_lights';
    var lightsInputs = document.querySelectorAll('[data-lights-switch]');

    function setLights(on, persist) {
      document.documentElement.classList.toggle('lights-off', !on);
      lightsInputs.forEach(function(input) {
        input.checked = on;
      });
      if (!persist) return;
      try {
        localStorage.setItem(lightsKey, on ? 'on' : 'off');
      } catch (error) {}
    }

    var lightsOn = true;
    try {
      lightsOn = localStorage.getItem(lightsKey) !== 'off';
    } catch (error) {}
    setLights(lightsOn, false);

    lightsInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        setLights(input.checked, true);
      });
    });

    document.querySelectorAll('.collection-page__filter-price-form').forEach(function(form) {
      form.addEventListener('submit', function() {
        ['min', 'max'].forEach(function(key) {
          var major = form.querySelector('[data-price-major="' + key + '"]');
          var cents = form.querySelector('[data-price-cents="' + key + '"]');
          if (!major || !cents) return;
          var raw = (major.value || '').trim();
          if (raw === '') {
            cents.disabled = true;
            return;
          }
          cents.disabled = false;
          cents.value = String(Math.round(parseFloat(raw) * 100));
        });
      });
    });

    // Sort dropdown toggle
    const sortTrigger = document.querySelector('[data-sort-trigger]');
    if (sortTrigger) {
      sortTrigger.addEventListener('click', function(e) {
        e.stopPropagation();
        const dropdown = this.closest('[data-sort-dropdown]');
        const isOpen = dropdown.classList.contains('collection-page__sort-dropdown--open');
        
        // Close filter dropdowns
        document.querySelectorAll('[data-filter-dropdown]').forEach(item => {
          item.classList.remove('collection-page__filter-dropdown--open');
        });
        
        // Toggle sort dropdown
        if (isOpen) {
          dropdown.classList.remove('collection-page__sort-dropdown--open');
        } else {
          dropdown.classList.add('collection-page__sort-dropdown--open');
        }
      });
    }

    // Sort option clicks
    const sortOptions = document.querySelectorAll('[data-sort-value]');
    sortOptions.forEach(option => {
      option.addEventListener('click', function() {
        const sortValue = this.dataset.sortValue;
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortValue);
        window.location.href = url.toString();
      });
    });

    // Filter dropdown toggles
    const filterTriggers = document.querySelectorAll('[data-filter-trigger]');
    
    filterTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        const dropdown = this.closest('[data-filter-dropdown]');
        const panel = dropdown.querySelector('[data-filter-panel]');
        const isOpen = dropdown.classList.contains('collection-page__filter-dropdown--open');
        
        // Close sort dropdown
        document.querySelectorAll('[data-sort-dropdown]').forEach(item => {
          item.classList.remove('collection-page__sort-dropdown--open');
        });
        
        // Close all other filter dropdowns
        document.querySelectorAll('[data-filter-dropdown]').forEach(item => {
          if (item !== dropdown) {
            item.classList.remove('collection-page__filter-dropdown--open');
          }
        });
        
        // Toggle current dropdown
        if (isOpen) {
          dropdown.classList.remove('collection-page__filter-dropdown--open');
        } else {
          dropdown.classList.add('collection-page__filter-dropdown--open');
        }
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-filter-dropdown]') && !e.target.closest('[data-sort-dropdown]')) {
        document.querySelectorAll('[data-filter-dropdown]').forEach(dropdown => {
          dropdown.classList.remove('collection-page__filter-dropdown--open');
        });
        document.querySelectorAll('[data-sort-dropdown]').forEach(dropdown => {
          dropdown.classList.remove('collection-page__sort-dropdown--open');
        });
      }
    });

    // Filter checkbox clicks
    const filterCheckboxes = document.querySelectorAll('.collection-page__filter-checkbox-input[data-filter-url]');
    
    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        if (this.checked) {
          window.location.href = this.dataset.filterUrl;
        }
      });
    });

    // Initialize wishlist buttons when page loads
    function initWishlistButtons() {
      if (window.wishlist && typeof window.wishlist.updateAllWishlistButtons === 'function') {
        window.wishlist.updateAllWishlistButtons();
      } else {
        // Wait for wishlist to be available
        setTimeout(initWishlistButtons, 100);
      }
    }

    // Initialize on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWishlistButtons);
    } else {
      initWishlistButtons();
    }

    // Update wishlist buttons when wishlist is updated
    document.addEventListener('wishlist:updated', function() {
      if (window.wishlist && typeof window.wishlist.updateAllWishlistButtons === 'function') {
        window.wishlist.updateAllWishlistButtons();
      }
    });
  })();

  (function() {
    var bar = document.querySelector('.collection-page__filter-bar');
    var header = document.querySelector('.header-wrapper');
    if (!bar || !header) return;

    var placeholder = document.createElement('div');
    placeholder.className = 'collection-page__filter-placeholder';
    placeholder.hidden = true;
    bar.parentNode.insertBefore(placeholder, bar);

    var stuck = false;
    var frame = 0;

    function headerLine() {
      return header.getBoundingClientRect().bottom;
    }

    function place() {
      var anchor = placeholder.getBoundingClientRect();
      bar.style.top = headerLine() + 'px';
      bar.style.left = anchor.left + 'px';
      bar.style.width = anchor.width + 'px';
    }

    function stick() {
      var style = window.getComputedStyle(bar);
      placeholder.style.height = (bar.offsetHeight + parseFloat(style.marginTop) + parseFloat(style.marginBottom)) + 'px';
      placeholder.hidden = false;
      stuck = true;
      bar.classList.add('is-stuck');
      header.classList.add('is-joined');
      place();
    }

    function release() {
      stuck = false;
      bar.classList.remove('is-stuck');
      header.classList.remove('is-joined');
      bar.style.top = '';
      bar.style.left = '';
      bar.style.width = '';
      placeholder.hidden = true;
    }

    function update() {
      frame = 0;
      var line = headerLine();
      if (!stuck) {
        if (bar.getBoundingClientRect().top <= line) stick();
      } else if (placeholder.getBoundingClientRect().top >= line - 1) {
        release();
      } else {
        place();
      }
    }

    function requestUpdate() {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-comparison"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sliders = document.querySelectorAll('[data-comparison-slider]');
  var ticking = false;
  var sliderData = {};
  var activeSlider = null;
  
  function updateSlider(slider, position) {
    var afterImage = slider.querySelector('.color-comparison__image-wrapper--after');
    var handle = slider.querySelector('[data-slider-handle]');
    if (!afterImage || !handle) return;
    
    var percent = position;
    
    if (percent === undefined || percent === null) {
      var rect = slider.getBoundingClientRect();
      var windowHeight = window.innerHeight;
      var sliderTop = rect.top;
      var sliderBottom = rect.bottom;
      var sliderHeight = rect.height;
      
      if (sliderTop < windowHeight && sliderBottom > 0) {
        var totalDistance = sliderHeight + windowHeight;
        var scrolled = windowHeight - sliderTop;
        percent = Math.max(0, Math.min(100, (scrolled / totalDistance) * 100));
      } else if (sliderTop >= windowHeight) {
        percent = 0;
      } else {
        percent = 100;
      }
    }
    
    percent = Math.max(0, Math.min(100, percent));
    
    handle.style.top = percent + '%';
    handle.style.transform = 'translateY(-50%)';
    
    afterImage.style.clipPath = 'inset(' + percent + '% 0 0 0)';
    
    var sliderId = slider.getAttribute('data-slider-id');
    if (sliderId) {
      var currentData = sliderData[sliderId];
      var isDragging = currentData ? currentData.isDragging : false;
      sliderData[sliderId] = { position: percent, isDragging: isDragging };
    }
  }
  
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        for (var i = 0; i < sliders.length; i++) {
          var slider = sliders[i];
          var sliderId = slider.getAttribute('data-slider-id');
          if (sliderId) {
            var data = sliderData[sliderId];
            if (!data || !data.isDragging) {
              updateSlider(slider);
            }
          }
        }
        ticking = false;
      });
      ticking = true;
    }
  }
  
  function handleDocumentMove(e) {
    if (!activeSlider) return;
    
    var slider = activeSlider;
    var sliderId = slider.getAttribute('data-slider-id');
    if (!sliderId) return;
    
    var data = sliderData[sliderId];
    if (!data || !data.isDragging) return;
    
    var clientY = e.touches ? e.touches[0].clientY : e.clientY;
    var rect = slider.getBoundingClientRect();
    var y = clientY - rect.top;
    var percent = Math.max(0, Math.min(100, (y / rect.height) * 100));
    
    updateSlider(slider, percent);
    e.preventDefault();
    e.stopPropagation();
  }
  
  function handleDocumentEnd(e) {
    if (!activeSlider) return;
    
    var slider = activeSlider;
    var sliderId = slider.getAttribute('data-slider-id');
    if (!sliderId) return;
    
    var handle = slider.querySelector('[data-slider-handle]');
    var button = slider.querySelector('.color-comparison__slider-button');
    
    var data = sliderData[sliderId];
    if (data) {
      sliderData[sliderId] = { position: data.position, isDragging: false };
    }
    
    slider.style.cursor = 'grab';
    if (handle) handle.style.cursor = 'ns-resize';
    if (button) button.style.cursor = 'ns-resize';
    
    activeSlider = null;
    
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
  
  document.addEventListener('mousemove', handleDocumentMove);
  document.addEventListener('mouseup', handleDocumentEnd);
  document.addEventListener('touchmove', handleDocumentMove, { passive: false });
  document.addEventListener('touchend', handleDocumentEnd);
  
  for (var i = 0; i < sliders.length; i++) {
    (function(index) {
      var slider = sliders[index];
      var afterImage = slider.querySelector('.color-comparison__image-wrapper--after');
      var handle = slider.querySelector('[data-slider-handle]');
      var button = slider.querySelector('.color-comparison__slider-button');
      
      if (!afterImage || !handle) return;
      
      var sliderId = 'slider-' + index;
      slider.setAttribute('data-slider-id', sliderId);
      
      sliderData[sliderId] = { position: 50, isDragging: false };
      
      updateSlider(slider, 50);
      
      function handleStart(e) {
        activeSlider = slider;
        var currentData = sliderData[sliderId];
        var startPosition = currentData ? currentData.position : 50;
        
        sliderData[sliderId] = { position: startPosition, isDragging: true };
        slider.style.cursor = 'grabbing';
        if (handle) handle.style.cursor = 'grabbing';
        if (button) button.style.cursor = 'grabbing';
        e.preventDefault();
        e.stopPropagation();
      }
      
      slider.addEventListener('mousedown', handleStart);
      handle.addEventListener('mousedown', handleStart);
      if (button) {
        button.addEventListener('mousedown', handleStart);
      }
      
      slider.addEventListener('touchstart', handleStart, { passive: false });
      handle.addEventListener('touchstart', handleStart, { passive: false });
      if (button) {
        button.addEventListener('touchstart', handleStart, { passive: false });
      }
    })(i);
  }
  
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  
  onScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  
  function initFAQ() {
    const faqPage = document.querySelector('[data-faq-page]');
    if (!faqPage) {
      // Retry after a short delay if element not found yet
      setTimeout(initFAQ, 100);
      return;
    }
    
    const faqItems = faqPage.querySelectorAll('[data-faq-toggle]');
    
    if (faqItems.length === 0) return;
    
    faqItems.forEach(function(toggle) {
      // Skip if already initialized
      if (toggle.dataset.faqInitialized === 'true') return;
      toggle.dataset.faqInitialized = 'true';
      
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const button = this;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const answerId = button.getAttribute('aria-controls');
        const answer = document.getElementById(answerId);
        const item = button.closest('.faq-page__item');
        
        if (!answer || !item) {
          console.warn('FAQ: Answer or item not found', { answerId, answer, item });
          return;
        }
        
        // Toggle current item
        if (isExpanded) {
          button.setAttribute('aria-expanded', 'false');
          answer.setAttribute('aria-hidden', 'true');
          item.classList.remove('faq-page__item--active');
        } else {
          button.setAttribute('aria-expanded', 'true');
          answer.setAttribute('aria-hidden', 'false');
          item.classList.add('faq-page__item--active');
        }
      });
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQ);
  } else {
    // DOM already loaded, initialize immediately
    initFAQ();
  }
  
  // Also initialize when Shopify theme editor updates
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId && document.querySelector('[data-faq-page]')) {
        initFAQ();
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-featured-products-section]');
    if (!section) return;
    
    const track = section.querySelector('[data-track]');
    const slides = section.querySelectorAll('[data-slide]');
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');
    
    if (!track || slides.length === 0) return;
    
    let currentIndex = 0;
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let autoplayInterval = null;
    
    function getVisibleSlides() {
      if (window.innerWidth >= 1440) return 3;
      if (window.innerWidth >= 1024) return 2;
      if (window.innerWidth >= 768) return 1.5;
      return 1;
    }
    
    function getSlideWidth() {
      const container = section.querySelector('.featured-products__carousel');
      const visibleSlides = getVisibleSlides();
      const gap = window.innerWidth >= 768 ? 40 : 24; // 2.5rem = 40px, 1.5rem = 24px
      const containerWidth = container.offsetWidth - (3 * 2 * 16); // padding compensation
      return (containerWidth - (gap * (visibleSlides - 1))) / visibleSlides;
    }
    
    function updateCarousel() {
      const slideWidth = getSlideWidth();
      const gap = window.innerWidth >= 768 ? 40 : 24;
      const translateX = -(currentIndex * (slideWidth + gap));
      track.style.transform = `translateX(${translateX}px)`;
      
      // Update button states - allow showing partial last slide
      const visibleSlides = getVisibleSlides();
      const maxIndex = slides.length - 1; // Allow going to last slide (partial visible)
      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
      }
      if (nextBtn) {
        nextBtn.disabled = currentIndex >= maxIndex;
      }
    }
    
    function nextSlide() {
      const maxIndex = slides.length - 1; // Allow showing last slide partially
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    }
    
    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    }
    
    function startAutoplay() {
      stopAutoplay();
      autoplayInterval = setInterval(() => {
        const maxIndex = slides.length - 1;
        if (currentIndex < maxIndex) {
          nextSlide();
        } else {
          currentIndex = 0;
          updateCarousel();
        }
      }, 5000);
    }
    
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }
    
    // Navigation buttons
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        stopAutoplay();
        nextSlide();
        startAutoplay();
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        stopAutoplay();
        prevSlide();
        startAutoplay();
      });
    }
    
    // Mouse drag support
    track.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = currentIndex * (getSlideWidth() + (window.innerWidth >= 768 ? 40 : 24));
      track.style.cursor = 'grabbing';
      stopAutoplay();
    });
    
    track.addEventListener('mouseleave', () => {
      isDragging = false;
      track.style.cursor = 'grab';
      startAutoplay();
    });
    
    track.addEventListener('mouseup', () => {
      isDragging = false;
      track.style.cursor = 'grab';
      startAutoplay();
    });
    
    track.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 2;
      const slideWidth = getSlideWidth();
      const gap = window.innerWidth >= 768 ? 40 : 24;
      const currentTranslate = -(currentIndex * (slideWidth + gap));
      track.style.transform = `translateX(${currentTranslate + walk}px)`;
    });
    
    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    
    track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });
    
    track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
      startAutoplay();
    }, { passive: true });
    
    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      } else {
        updateCarousel();
      }
    }
    
    // Initialize
    track.style.cursor = 'grab';
    updateCarousel();
    startAutoplay();
    
    // Pause on hover
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    
    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        updateCarousel();
      }, 250);
    });
    
    // Re-initialize on section load (for theme editor)
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(e) {
        if (e.detail.sectionId && section.closest('[data-section-id="' + e.detail.sectionId + '"]')) {
          location.reload();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initLanguageSwitcher() {
      const switchers = document.querySelectorAll('.footer__language-switcher[data-language-switcher]');
      
      switchers.forEach(switcher => {
        const button = switcher.querySelector('[data-language-button]');
        const dropdown = switcher.querySelector('[data-language-dropdown]');
        const options = switcher.querySelectorAll('[data-language-option]');
        const form = switcher.querySelector('form');
        const hiddenInput = switcher.querySelector('[data-locale-input]');
        
        if (!button || !dropdown || !form) return;
        
        let isOpen = false;
        
        const openDropdown = () => {
          isOpen = true;
          button.classList.add('language-switcher__button--active');
          button.setAttribute('aria-expanded', 'true');
          dropdown.classList.add('language-switcher__dropdown--open');
        };
        
        const closeDropdown = () => {
          isOpen = false;
          button.classList.remove('language-switcher__button--active');
          button.setAttribute('aria-expanded', 'false');
          dropdown.classList.remove('language-switcher__dropdown--open');
        };
        
        // Button click handler
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (isOpen) {
            closeDropdown();
          } else {
            openDropdown();
          }
        });
        
        // Close on outside click
        document.addEventListener('click', function(e) {
          if (!switcher.contains(e.target)) {
            closeDropdown();
          }
        });
        
        // Option click handlers
        options.forEach(option => {
          option.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const localeCode = option.getAttribute('data-locale-code');
            
            if (!localeCode) return;
            
            if (hiddenInput) {
              hiddenInput.value = localeCode;
            }
            
            // Update button text
            const currentText = switcher.querySelector('.language-switcher__current');
            if (currentText) {
              currentText.textContent = localeCode.toUpperCase();
            }
            
            // Update active state
            options.forEach(opt => {
              opt.classList.remove('language-switcher__option--active');
              const checkIcon = opt.querySelector('.language-switcher__check');
              if (checkIcon) {
                checkIcon.remove();
              }
            });
            
            option.classList.add('language-switcher__option--active');
            
            // Add checkmark to selected option
            if (!option.querySelector('.language-switcher__check')) {
              const checkIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
              checkIcon.setAttribute('class', 'language-switcher__check');
              checkIcon.setAttribute('width', '14');
              checkIcon.setAttribute('height', '14');
              checkIcon.setAttribute('viewBox', '0 0 14 14');
              checkIcon.setAttribute('fill', 'none');
              checkIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
              const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
              path.setAttribute('d', 'M11.6667 3.5L5.25 9.91667L2.33334 7');
              path.setAttribute('stroke', 'currentColor');
              path.setAttribute('stroke-width', '1.5');
              path.setAttribute('stroke-linecap', 'round');
              path.setAttribute('stroke-linejoin', 'round');
              checkIcon.appendChild(path);
              option.appendChild(checkIcon);
            }
            
            closeDropdown();
            
            // Submit form
            if (form) {
              form.submit();
            }
          });
        });
        
        // Keyboard navigation
        button.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!isOpen) {
              openDropdown();
            } else {
              closeDropdown();
            }
          } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (!isOpen) {
              openDropdown();
            }
            if (options.length > 0) {
              options[0].focus();
            }
          }
        });
        
        options.forEach((option, index) => {
          option.addEventListener('keydown', function(e) {
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              const next = options[index + 1] || options[0];
              if (next) next.focus();
            } else if (e.key === 'ArrowUp') {
              e.preventDefault();
              const prev = options[index - 1] || options[options.length - 1];
              if (prev) prev.focus();
            } else if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              option.click();
            } else if (e.key === 'Escape') {
              e.preventDefault();
              closeDropdown();
              button.focus();
            }
          });
        });
      });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLanguageSwitcher);
    } else {
      initLanguageSwitcher();
    }
    
    // Re-initialize on dynamic content updates (for Shopify theme editor)
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', initLanguageSwitcher);
      document.addEventListener('shopify:section:reorder', initLanguageSwitcher);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function syncHeaderOffset() {
    var header = document.querySelector('.header-wrapper.header--sticky');
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--header-offset', headerHeight + 'px');
  }

  syncHeaderOffset();
  window.addEventListener('resize', syncHeaderOffset);
  window.addEventListener('load', syncHeaderOffset);

  document.addEventListener('DOMContentLoaded', function() {
    syncHeaderOffset();

    var menuToggle = document.querySelector('.header__menu-toggle');
    var mobileDrawer = document.querySelector('[data-mobile-drawer]');
    if (menuToggle && mobileDrawer) {
      document.querySelectorAll('body > [data-mobile-drawer]').forEach(function(node) {
        if (node !== mobileDrawer) node.remove();
      });
      document.body.appendChild(mobileDrawer);
      var setDrawer = function(open) {
        mobileDrawer.classList.toggle('is-open', open);
        menuToggle.classList.toggle('is-open', open);
        menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('mobile-drawer-open', open);
      };
      menuToggle.addEventListener('click', function() {
        setDrawer(!mobileDrawer.classList.contains('is-open'));
      });
      mobileDrawer.querySelectorAll('[data-drawer-close], .mobile-drawer__list a').forEach(function(node) {
        node.addEventListener('click', function() { setDrawer(false); });
      });
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && document.querySelector('[data-search-layer].is-open')) return;
        if (event.key === 'Escape') setDrawer(false);
      });
    }

    // Language Switcher Dropdown
    function initLanguageSwitcher() {
      const languageSwitchers = document.querySelectorAll('[data-language-switcher]');
      
      if (languageSwitchers.length === 0) return;
      
      languageSwitchers.forEach(switcher => {
        const button = switcher.querySelector('[data-language-button]');
        const dropdown = switcher.querySelector('[data-language-dropdown]');
        const options = switcher.querySelectorAll('[data-language-option]');
        const form = switcher.querySelector('.localization-form');
        const hiddenInput = switcher.querySelector('[data-locale-input]');
        
        if (!button || !dropdown) {
          console.warn('Language switcher elements not found');
          return;
        }

        let isOpen = false;
        let clickOutsideHandler = null;
        let escapeHandler = null;

        function openDropdown() {
          if (isOpen) return;
          isOpen = true;
          button.setAttribute('aria-expanded', 'true');
          button.classList.add('language-switcher__button--active');
          dropdown.classList.add('language-switcher__dropdown--open');
          
          // Create bound handlers
          clickOutsideHandler = function(e) {
            if (!switcher.contains(e.target)) {
              closeDropdown();
            }
          };
          
          escapeHandler = function(e) {
            if (e.key === 'Escape') {
              closeDropdown();
              button.focus();
            }
          };
          
          // Use setTimeout to avoid immediate trigger
          setTimeout(() => {
            document.addEventListener('click', clickOutsideHandler);
            document.addEventListener('keydown', escapeHandler);
          }, 10);
        }

        function closeDropdown() {
          if (!isOpen) return;
          isOpen = false;
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('language-switcher__button--active');
          dropdown.classList.remove('language-switcher__dropdown--open');
          
          if (clickOutsideHandler) {
            document.removeEventListener('click', clickOutsideHandler);
            clickOutsideHandler = null;
          }
          if (escapeHandler) {
            document.removeEventListener('keydown', escapeHandler);
            escapeHandler = null;
          }
        }

        // Button click handler
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          if (isOpen) {
            closeDropdown();
          } else {
            openDropdown();
          }
        });

        // Option click handlers
        options.forEach(option => {
          option.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const localeCode = option.getAttribute('data-locale-code');
            
            if (!localeCode) return;
            
            if (hiddenInput) {
              hiddenInput.value = localeCode;
            }
            
            // Update button text
            const currentText = switcher.querySelector('.language-switcher__current');
            if (currentText) {
              currentText.textContent = option.getAttribute('data-locale-label') || localeCode.toUpperCase();
            }
            
            // Update active state
            options.forEach(opt => {
              opt.classList.remove('language-switcher__option--active');
              const checkIcon = opt.querySelector('.language-switcher__check');
              if (checkIcon) {
                checkIcon.remove();
              }
            });
            
            option.classList.add('language-switcher__option--active');
            
            // Add checkmark to selected option
            if (!option.querySelector('.language-switcher__check')) {
              const checkIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
              checkIcon.setAttribute('class', 'language-switcher__check');
              checkIcon.setAttribute('width', '14');
              checkIcon.setAttribute('height', '14');
              checkIcon.setAttribute('viewBox', '0 0 14 14');
              checkIcon.setAttribute('fill', 'none');
              checkIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
              const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
              path.setAttribute('d', 'M11.6667 3.5L5.25 9.91667L2.33334 7');
              path.setAttribute('stroke', 'currentColor');
              path.setAttribute('stroke-width', '1.5');
              path.setAttribute('stroke-linecap', 'round');
              path.setAttribute('stroke-linejoin', 'round');
              checkIcon.appendChild(path);
              option.appendChild(checkIcon);
            }
            
            closeDropdown();
            
            // Submit form
            if (form) {
              form.submit();
            }
          });
        });

        // Keyboard navigation
        button.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!isOpen) {
              openDropdown();
            } else {
              closeDropdown();
            }
          } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (!isOpen) {
              openDropdown();
            }
            if (options.length > 0) {
              options[0].focus();
            }
          }
        });

        options.forEach((option, index) => {
          option.addEventListener('keydown', function(e) {
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              const next = options[index + 1] || options[0];
              if (next) next.focus();
            } else if (e.key === 'ArrowUp') {
              e.preventDefault();
              const prev = options[index - 1] || options[options.length - 1];
              if (prev) prev.focus();
            } else if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              option.click();
            } else if (e.key === 'Escape') {
              e.preventDefault();
              closeDropdown();
              button.focus();
            }
          });
        });
      });
    }

    // Initialize
    initLanguageSwitcher();
    
    // Re-initialize on dynamic content updates (for Shopify theme editor)
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', initLanguageSwitcher);
      document.addEventListener('shopify:section:reorder', initLanguageSwitcher);
    }

    const searchOpen = document.querySelector('[data-search-open]');
    const searchLayer = document.querySelector('[data-search-layer]');
    if (searchOpen && searchLayer) {
      document.querySelectorAll('[data-search-layer]').forEach(function(node) {
        if (node !== searchLayer) node.remove();
      });
      document.body.appendChild(searchLayer);
      const searchInput = searchLayer.querySelector('[data-search-input]');
      const searchResults = searchLayer.querySelector('[data-search-results]');
      const searchForm = searchLayer.querySelector('form');
      const searchPanel = searchLayer.querySelector('.search-layer__panel');
      const liveSearch = searchLayer.hasAttribute('data-live-search');
      let searchTimer = null;
      let searchRequest = 0;

      function escapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, function(character) {
          return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character];
        });
      }

      function formatPrice(value) {
        const amount = Number(value);
        if (!window.themeFormatMoney || !isFinite(amount)) return '';
        const cents = String(value).indexOf('.') === -1 ? amount : Math.round(amount * 100);
        return window.themeFormatMoney(cents);
      }

      function productImage(product) {
        let image = product.featured_image || product.image || '';
        if (image && typeof image === 'object') image = image.url || image.src || '';
        if (!image) return '';
        if (image.indexOf('width=') === -1) {
          image += (image.indexOf('?') === -1 ? '?' : '&') + 'width=180';
        }
        return image;
      }

      function renderResults(products, term) {
        if (!products.length) {
          searchResults.innerHTML = '<p class="search-layer__empty">' + escapeHtml(searchLayer.dataset.searchEmpty) + '</p>';
          searchInput.setAttribute('aria-expanded', 'false');
          return;
        }
        const allUrl = searchLayer.dataset.searchUrl + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
        searchResults.innerHTML = products.map(function(product, index) {
          const image = productImage(product);
          return '<a class="search-layer__item" style="--i:' + index + '" href="' + escapeHtml(product.url) + '">' +
            (image ? '<img src="' + escapeHtml(image) + '" alt="" width="72" height="90">' : '<span class="search-layer__media"></span>') +
            '<span class="search-layer__name">' + escapeHtml(product.title) + '</span>' +
            '<span class="search-layer__price">' + escapeHtml(formatPrice(product.price)) + '</span></a>';
        }).join('') + '<a class="search-layer__all" href="' + escapeHtml(allUrl) + '">' + escapeHtml(searchLayer.dataset.searchAll) + '</a>';
        searchInput.setAttribute('aria-expanded', 'true');
      }

      function clearResults() {
        searchResults.innerHTML = '';
        searchInput.setAttribute('aria-expanded', 'false');
      }

      function openSearch() {
        const drawer = document.querySelector('[data-mobile-drawer]');
        if (drawer) drawer.classList.remove('is-open');
        document.body.classList.remove('mobile-drawer-open');
        searchLayer.classList.add('is-open');
        searchLayer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('search-layer-open');
        searchOpen.setAttribute('aria-expanded', 'true');
        window.setTimeout(function() { searchInput.focus(); }, 40);
      }

      function closeSearch() {
        if (!searchLayer.classList.contains('is-open')) return;
        searchLayer.classList.remove('is-open');
        searchLayer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('search-layer-open');
        searchOpen.setAttribute('aria-expanded', 'false');
        searchInput.value = '';
        clearResults();
        searchInput.blur();
      }

      searchOpen.addEventListener('click', openSearch);
      searchLayer.addEventListener('click', closeSearch);
      searchPanel.addEventListener('click', function(event) { event.stopPropagation(); });

      document.addEventListener('keydown', function(event) {
        var key = (event.key || '').toLowerCase();
        if ((event.ctrlKey || event.metaKey) && !event.altKey && !event.shiftKey && key === 'f') {
          event.preventDefault();
          openSearch();
          return;
        }
        if (event.key === 'Escape' && searchLayer.classList.contains('is-open')) {
          event.preventDefault();
          closeSearch();
        }
      });

      searchForm.addEventListener('submit', function(event) {
        if (!searchInput.value.trim()) event.preventDefault();
      });

      searchInput.addEventListener('input', function() {
        const term = this.value.trim();
        clearTimeout(searchTimer);
        if (!liveSearch || term.length < 2) {
          clearResults();
          return;
        }
        const requestId = ++searchRequest;
        searchTimer = setTimeout(function() {
          const params = new URLSearchParams({
            q: term,
            'resources[type]': 'product',
            'resources[limit]': '6',
            'resources[options][unavailable_products]': 'last',
            'resources[options][fields]': 'title,product_type,variants.title,vendor'
          });
          params.append('options[prefix]', 'last');
          fetch('/search/suggest.json?' + params.toString(), { headers: { Accept: 'application/json' } })
            .then(function(response) { return response.ok ? response.json() : null; })
            .then(function(data) {
              if (requestId !== searchRequest) return;
              const products = data && data.resources && data.resources.results ? data.resources.results.products || [] : [];
              renderResults(products, term);
            })
            .catch(function() {
              if (requestId === searchRequest) clearResults();
            });
        }, 180);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const slider = document.querySelector('[data-hero-slider]');
    if (!slider || slider.children.length <= 1) return;

    const slides = Array.from(slider.children);
    const prevBtn = document.querySelector('[data-slider-prev]');
    const nextBtn = document.querySelector('[data-slider-next]');
    const dots = document.querySelectorAll('[data-slider-dot]');
    
    let currentSlide = 0;
    let autoPlayInterval;
    const autoPlayDelay = 5000; // 5 seconds
    const enableAutoPlay = true;

    function syncVideos(index) {
      slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (i === index) {
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    function showSlide(index) {
      // Update slides
      slides.forEach((slide, i) => {
        slide.classList.toggle('hero-banner-slider__slide--active', i === index);
      });
      syncVideos(index);

      // Update dots
      dots.forEach((dot, i) => {
        dot.classList.toggle('hero-banner-slider__dot--active', i === index);
      });

      currentSlide = index;
    }

    function nextSlide() {
      const next = (currentSlide + 1) % slides.length;
      showSlide(next);
    }

    function prevSlide() {
      const prev = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(prev);
    }

    function startAutoPlay() {
      if (!enableAutoPlay) return;
      autoPlayInterval = setInterval(nextSlide, autoPlayDelay);
    }

    function stopAutoPlay() {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
      }
    }

    // Navigation buttons
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        stopAutoPlay();
        nextSlide();
        startAutoPlay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        stopAutoPlay();
        prevSlide();
        startAutoPlay();
      });
    }

    // Dots navigation
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        stopAutoPlay();
        showSlide(index);
        startAutoPlay();
      });
    });

    // Pause on hover
    if (slider.parentElement) {
      slider.parentElement.addEventListener('mouseenter', stopAutoPlay);
      slider.parentElement.addEventListener('mouseleave', startAutoPlay);
    }

    // Start auto-play
    startAutoPlay();

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });

    slider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });

    function handleSwipe() {
      if (touchEndX < touchStartX - 50) {
        // Swipe left - next
        stopAutoPlay();
        nextSlide();
        startAutoPlay();
      }
      if (touchEndX > touchStartX + 50) {
        // Swipe right - prev
        stopAutoPlay();
        prevSlide();
        startAutoPlay();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login-page"]) return;
  try {
    
(function() {
  'use strict';
  
  var loginPage = document.querySelector('[data-login-page]');
  if (!loginPage) {
    return;
  }

  var passwordToggle = loginPage.querySelector('[data-password-toggle]');
  if (passwordToggle) {
    passwordToggle.addEventListener('click', function() {
      var passwordInput = loginPage.querySelector('#customer_password');
      var hideIcon = passwordToggle.querySelector('.login-form__password-icon--hide');
      var showIcon = passwordToggle.querySelector('.login-form__password-icon--show');
      
      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        if (hideIcon) hideIcon.style.display = 'none';
        if (showIcon) showIcon.style.display = 'block';
      } else {
        passwordInput.type = 'password';
        if (hideIcon) hideIcon.style.display = 'block';
        if (showIcon) showIcon.style.display = 'none';
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-recommendations-section]');
    if (!section) return;
    
    const track = section.querySelector('[data-track]');
    const slides = section.querySelectorAll('[data-slide]');
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');
    const dotsContainer = section.querySelector('[data-dots]');
    
    if (!track || slides.length === 0) return;
    
    let currentIndex = 0;
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let autoplayInterval = null;
    
    function getVisibleSlides() {
      if (window.innerWidth >= 1440) return 4;
      if (window.innerWidth >= 1024) return 4;
      if (window.innerWidth >= 768) return 3;
      return 1;
    }
    
    function getSlideWidth() {
      const container = section.querySelector('.product-recommendations__carousel');
      const visibleSlides = getVisibleSlides();
      const gap = 24; // 1.5rem = 24px
      return (container.offsetWidth - (gap * (visibleSlides - 1))) / visibleSlides;
    }
    
    function updateCarousel() {
      const slideWidth = getSlideWidth();
      const visibleSlides = getVisibleSlides();
      const maxIndex = Math.max(0, slides.length - visibleSlides);
      
      // Smooth scroll
      track.style.transform = `translateX(-${currentIndex * (slideWidth + 24)}px)`;
      
      // Update button states
      if (prevBtn) {
        const isFirst = currentIndex === 0;
        prevBtn.disabled = isFirst;
        prevBtn.classList.toggle('product-recommendations__arrow--disabled', isFirst);
        prevBtn.setAttribute('aria-disabled', isFirst);
      }
      
      if (nextBtn) {
        const isLast = currentIndex >= maxIndex;
        nextBtn.disabled = isLast;
        nextBtn.classList.toggle('product-recommendations__arrow--disabled', isLast);
        nextBtn.setAttribute('aria-disabled', isLast);
      }
      
      // Update dots
      updateDots();
    }
    
    function updateDots() {
      if (!dotsContainer) return;
      
      const visibleSlides = getVisibleSlides();
      const totalPages = Math.ceil(slides.length / visibleSlides);
      
      dotsContainer.innerHTML = '';
      
      if (totalPages <= 1) {
        dotsContainer.style.display = 'none';
        return;
      }
      
      dotsContainer.style.display = 'flex';
      
      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-recommendations__dot';
        dot.setAttribute('aria-label', ((window.themeStrings && window.themeStrings.page) || 'Page') + ' ' + (i + 1));
        dot.setAttribute('data-dot-index', i);
        
        const pageStart = i * visibleSlides;
        const isActive = currentIndex >= pageStart && currentIndex < pageStart + visibleSlides;
        if (isActive) {
          dot.classList.add('product-recommendations__dot--active');
        }
        
        dot.addEventListener('click', () => {
          goToSlide(pageStart);
        });
        
        dotsContainer.appendChild(dot);
      }
    }
    
    function goToSlide(index) {
      const visibleSlides = getVisibleSlides();
      const maxIndex = Math.max(0, slides.length - visibleSlides);
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      updateCarousel();
    }
    
    function nextSlide() {
      const visibleSlides = getVisibleSlides();
      const maxIndex = Math.max(0, slides.length - visibleSlides);
      if (currentIndex < maxIndex) {
        goToSlide(currentIndex + 1);
      } else {
        goToSlide(0); // Loop back to start
      }
    }
    
    function prevSlide() {
      const visibleSlides = getVisibleSlides();
      const maxIndex = Math.max(0, slides.length - visibleSlides);
      if (currentIndex > 0) {
        goToSlide(currentIndex - 1);
      } else {
        goToSlide(maxIndex); // Loop to end
      }
    }
    
    // Navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        prevSlide();
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        nextSlide();
      });
    }
    
    // Keyboard navigation
    section.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        prevSlide();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        nextSlide();
      }
    });
    
    // Touch/Swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    
    track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      isDragging = true;
    }, { passive: true });
    
    track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      isDragging = false;
      handleSwipe();
    }, { passive: true });
    
    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    }
    
    // Mouse drag support
    let mouseDown = false;
    let mouseStartX = 0;
    
    track.addEventListener('mousedown', (e) => {
      mouseDown = true;
      mouseStartX = e.pageX;
      track.style.cursor = 'grabbing';
      track.style.userSelect = 'none';
    });
    
    track.addEventListener('mouseleave', () => {
      mouseDown = false;
      track.style.cursor = 'grab';
      track.style.userSelect = '';
    });
    
    track.addEventListener('mouseup', () => {
      mouseDown = false;
      track.style.cursor = 'grab';
      track.style.userSelect = '';
    });
    
    track.addEventListener('mousemove', (e) => {
      if (!mouseDown) return;
      e.preventDefault();
      const diff = mouseStartX - e.pageX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
        mouseDown = false;
        track.style.cursor = 'grab';
        track.style.userSelect = '';
      }
    });
    
    // Initialize
    updateCarousel();
    updateDots();
    
    // Update on resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateCarousel();
        updateDots();
      }, 250);
    });
    
    // Intersection Observer for animations
    const slideObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('product-recommendations__slide--visible');
        }
      });
    }, {
      rootMargin: '50px',
      threshold: 0.1
    });
    
    slides.forEach(slide => {
      slideObserver.observe(slide);
    });
    
    // Pause autoplay on hover
    const wrapper = section.querySelector('.product-recommendations__wrapper');
    if (wrapper) {
      wrapper.addEventListener('mouseenter', () => {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-stacked-gallery"]) return;
  try {
    
  (function() {
    const section = document.querySelector('.product-stacked-gallery');
    if (!section) return;
    
    const product = JSON.parse(section.dataset.product);
    const moneyFormat = JSON.parse(section.dataset.moneyFormat);
    const gallery = section.querySelector('[data-product-gallery]');
    const mainImageWrapper = section.querySelector('[data-main-image-wrapper]');
    const infoWrapper = section.querySelector('[data-product-info]');
    
    if (!gallery || !mainImageWrapper) return;
    
    // Get all image wrappers
    const imageWrappers = mainImageWrapper.querySelectorAll('.product-stacked-gallery__image-wrapper');
    const thumbnails = section.querySelectorAll('[data-thumbnails] button');
    
    // Thumbnail navigation
    const thumbnailsWrapper = section.querySelector('[data-thumbnails-wrapper]');
    const thumbnailsContainer = section.querySelector('[data-thumbnails]');
    const thumbNavPrev = section.querySelector('[data-thumb-nav="prev"]');
    const thumbNavNext = section.querySelector('[data-thumb-nav="next"]');
    
    if (thumbnailsContainer && thumbNavPrev && thumbNavNext) {
      const updateNavButtons = () => {
        const container = thumbnailsContainer;
        const scrollLeft = container.scrollLeft;
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;
        
        thumbNavPrev.disabled = scrollLeft <= 0;
        thumbNavNext.disabled = scrollLeft >= scrollWidth - clientWidth - 1;
      };

      thumbNavPrev.addEventListener('click', () => {
        thumbnailsContainer.scrollBy({ left: -100, behavior: 'smooth' });
      });

      thumbNavNext.addEventListener('click', () => {
        thumbnailsContainer.scrollBy({ left: 100, behavior: 'smooth' });
      });

      thumbnailsContainer.addEventListener('scroll', updateNavButtons);
      updateNavButtons();

      // Thumbnail click handler - change main image
      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          if (imageWrappers[index]) {
            // Remove active class from all images
            imageWrappers.forEach(img => img.classList.remove('product-stacked-gallery__image-wrapper--active'));
            
            // Add active class to selected image
            imageWrappers[index].classList.add('product-stacked-gallery__image-wrapper--active');
            
            // Update thumbnail active state
            thumbnails.forEach(t => t.classList.remove('product-stacked-gallery__thumbnail--active'));
            thumb.classList.add('product-stacked-gallery__thumbnail--active');
            
            // Scroll thumbnail into view
            thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });
    }
    
    
    // Image Zoom & Lightbox functionality
    const imageContainers = section.querySelectorAll('[data-image-container]');
    const lightbox = section.querySelector('[data-lightbox]');
    const lightboxImage = section.querySelector('[data-lightbox-image]');
    const lightboxPrev = section.querySelector('[data-lightbox-prev]');
    const lightboxNext = section.querySelector('[data-lightbox-next]');
    const lightboxClose = section.querySelectorAll('[data-lightbox-close]');
    
    // Zoom functionality - click to toggle zoom mode
    let zoomActive = false;
    let activeContainer = null;
    let activeImage = null;
    
    if (imageContainers.length) {
      imageContainers.forEach((container, index) => {
        const img = container.querySelector('.product-stacked-gallery__image');
        const zoomHint = container.querySelector('[data-zoom-hint]');
        const zoomImageUrl = img?.dataset.zoomImage;
        if (!zoomImageUrl) return;
        
        // Show zoom hint on hover (only when zoom is not active)
        container.addEventListener('mouseenter', () => {
          if (!zoomActive && zoomHint) {
            zoomHint.classList.add('product-stacked-gallery__zoom-hint--active');
          }
        });
        
        container.addEventListener('mouseleave', () => {
          if (zoomHint) {
            zoomHint.classList.remove('product-stacked-gallery__zoom-hint--active');
          }
        });
        
        // Click to toggle zoom mode
        container.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Hide hint when zoom is activated
          if (zoomHint) {
            zoomHint.classList.remove('product-stacked-gallery__zoom-hint--active');
          }
          
          // If zoom is already active on this container, close zoom
          if (zoomActive && activeContainer === container) {
            closeZoom();
            return;
          }
          
          // If zoom is active on another container, close it first
          if (zoomActive && activeContainer !== container) {
            closeZoom();
          }
          
          // Activate zoom on this container
          activateZoom(container, img, zoomImageUrl);
        });
        
        // Mouse move to pan zoomed image
        container.addEventListener('mousemove', (e) => {
          if (!zoomActive || activeContainer !== container || !activeImage) return;
          
          const containerRect = container.getBoundingClientRect();
          
          // Get mouse position relative to container
          const mouseX = e.clientX - containerRect.left;
          const mouseY = e.clientY - containerRect.top;
          
          // Calculate zoom factor (2x)
          const zoomFactor = 2;
          
          // Calculate percentage within container (0-100)
          const xPercent = Math.max(0, Math.min(100, (mouseX / containerRect.width) * 100));
          const yPercent = Math.max(0, Math.min(100, (mouseY / containerRect.height) * 100));
          
          // Calculate zoomed image dimensions
          const zoomedImgWidth = containerRect.width * zoomFactor;
          const zoomedImgHeight = containerRect.height * zoomFactor;
          
          // Calculate desired translation to center the cursor area
          let translateX = (xPercent / 100) * zoomedImgWidth - containerRect.width / 2;
          let translateY = (yPercent / 100) * zoomedImgHeight - containerRect.height / 2;
          
          // Calculate maximum allowed translation (to prevent white space)
          // When zoomed, image is 2x larger, so we can move it by half the difference
          const maxTranslateX = (zoomedImgWidth - containerRect.width) / 2;
          const maxTranslateY = (zoomedImgHeight - containerRect.height) / 2;
          
          // Clamp translation to keep image within bounds
          // Negative values would show white space on left/top
          // Positive values beyond max would show white space on right/bottom
          translateX = Math.max(0, Math.min(maxTranslateX, translateX));
          translateY = Math.max(0, Math.min(maxTranslateY, translateY));
          
          // Apply transform to image (negative because we're moving the image, not the viewport)
          activeImage.style.transform = `translate(${-translateX}px, ${-translateY}px) scale(${zoomFactor})`;
        });
      });
      
      function activateZoom(container, img, zoomImageUrl) {
        zoomActive = true;
        activeContainer = container;
        
        // Add zoom class to container
        container.classList.add('product-stacked-gallery__image-container--zoomed');
        
        // Get the original image element
        activeImage = img;
        
        // Load high-res image if needed
        if (img.src !== zoomImageUrl && !img.dataset.zoomLoaded) {
          const highResImg = new Image();
          highResImg.onload = () => {
            img.src = zoomImageUrl;
            img.dataset.zoomLoaded = 'true';
          };
          highResImg.src = zoomImageUrl;
        }
        
        // Set cursor style
        container.style.cursor = 'move';
        document.body.style.cursor = 'move';
      }
      
      function closeZoom() {
        if (!zoomActive || !activeContainer || !activeImage) return;
        
        zoomActive = false;
        activeContainer.classList.remove('product-stacked-gallery__image-container--zoomed');
        activeImage.style.transform = '';
        activeContainer.style.cursor = '';
        document.body.style.cursor = '';
        
        // Hide zoom hint if it exists
        const zoomHint = activeContainer.querySelector('[data-zoom-hint]');
        if (zoomHint) {
          zoomHint.classList.remove('product-stacked-gallery__zoom-hint--active');
        }
        
        activeContainer = null;
        activeImage = null;
      }
      
      // Close zoom when clicking outside
      document.addEventListener('click', (e) => {
        if (zoomActive && activeContainer && !activeContainer.contains(e.target)) {
          closeZoom();
        }
      });
    }
    
    // Lightbox functionality
    if (lightbox) {
      let currentLightboxIndex = 0;
      
      // Get all image URLs for lightbox
      const allImages = [];
      imageWrappers.forEach((wrapper, idx) => {
        const img = wrapper.querySelector('[data-zoom-image]');
        if (img && img.dataset.zoomImage) {
          allImages.push({
            url: img.dataset.zoomImage,
            alt: img.alt || '',
            index: idx
          });
        }
      });
      
      // Double click to open lightbox
      if (imageContainers.length) {
        imageContainers.forEach((container, index) => {
          const img = container.querySelector('[data-zoom-image]');
          if (!img) return;
          
          container.addEventListener('dblclick', (e) => {
            if (zoomActive) {
              closeZoom();
            }
            
            e.preventDefault();
            e.stopPropagation();
            
            const clickedImageUrl = img.dataset.zoomImage;
            const imageIndex = allImages.findIndex(img => img.url === clickedImageUrl);
            if (imageIndex !== -1) {
              currentLightboxIndex = imageIndex;
              openLightbox(imageIndex);
            }
          });
        });
      }
      
      function openLightbox(index) {
        if (allImages[index]) {
          const imageData = allImages[index];
          lightboxImage.src = imageData.url;
          lightboxImage.alt = imageData.alt;
          lightbox.classList.add('product-stacked-gallery__lightbox--active');
          document.body.style.overflow = 'hidden';
          updateLightboxButtons();
        }
      }
      
      function closeLightbox() {
        lightbox.classList.remove('product-stacked-gallery__lightbox--active');
        document.body.style.overflow = '';
      }
      
      function updateLightboxButtons() {
        if (lightboxPrev) {
          lightboxPrev.disabled = currentLightboxIndex === 0;
        }
        if (lightboxNext) {
          lightboxNext.disabled = currentLightboxIndex === allImages.length - 1;
        }
      }
      
      function nextImage() {
        if (currentLightboxIndex < allImages.length - 1) {
          currentLightboxIndex++;
          openLightbox(currentLightboxIndex);
        }
      }
      
      function prevImage() {
        if (currentLightboxIndex > 0) {
          currentLightboxIndex--;
          openLightbox(currentLightboxIndex);
        }
      }
      
      // Lightbox controls
      if (lightboxPrev) {
        lightboxPrev.addEventListener('click', (e) => {
          e.stopPropagation();
          prevImage();
        });
      }
      
      if (lightboxNext) {
        lightboxNext.addEventListener('click', (e) => {
          e.stopPropagation();
          nextImage();
        });
      }
      
      lightboxClose.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          closeLightbox();
        });
      });
      
      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (!lightbox.classList.contains('product-stacked-gallery__lightbox--active')) return;
        
        if (e.key === 'Escape') {
          closeLightbox();
        } else if (e.key === 'ArrowLeft') {
          prevImage();
        } else if (e.key === 'ArrowRight') {
          nextImage();
        }
      });
    }
    
    // Variant selection
    const variantButtons = section.querySelectorAll('.product-stacked-gallery__variant-button');
    const variantSelects = section.querySelectorAll('[data-option-select]');
    const variantIdInput = document.getElementById('product-variant-id-stacked');
    
    function updateVariant() {
      const selectedOptions = {};
      variantButtons.forEach(btn => {
        if (btn.classList.contains('product-stacked-gallery__variant-button--active')) {
          selectedOptions[btn.dataset.option] = btn.dataset.value;
        }
      });
      variantSelects.forEach(select => {
        if (select.value) {
          selectedOptions[select.dataset.optionSelect] = select.value;
        }
      });
      
      const variant = product.variants.find(v => {
        return v.options.every((option, index) => {
          return option === selectedOptions[String(index + 1)];
        });
      });
      
      if (variant) {
        variantIdInput.value = variant.id;
        
        // Update price
        const priceEl = document.getElementById('product-price-display');
        if (priceEl) {
          if (variant.price !== variant.compare_at_price && variant.compare_at_price) {
            priceEl.innerHTML = `
              <span class="product-stacked-gallery__price-regular">${Shopify.formatMoney(variant.price, moneyFormat)}</span>
              <span class="product-stacked-gallery__price-compare">${Shopify.formatMoney(variant.compare_at_price, moneyFormat)}</span>
            `;
          } else {
            priceEl.innerHTML = `<span class="product-stacked-gallery__price-regular">${Shopify.formatMoney(variant.price, moneyFormat)}</span>`;
          }
        }
        
        // Update availability
        const addToCartBtn = section.querySelector('.product-stacked-gallery__add-to-cart');
        const addToCartTextEl = section.querySelector('.product-stacked-gallery__add-to-cart-text');
        const buyNowBtn = section.querySelector('.product-stacked-gallery__buy-now');
        
        if (addToCartBtn && addToCartTextEl) {
          if (variant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.classList.remove('product-stacked-gallery__add-to-cart--disabled');
            addToCartTextEl.textContent = 'Add to Cart';
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.classList.add('product-stacked-gallery__add-to-cart--disabled');
            addToCartTextEl.textContent = 'Sold Out';
          }
        }
        
        if (buyNowBtn) {
          if (variant.available) {
            buyNowBtn.disabled = false;
            buyNowBtn.classList.remove('product-stacked-gallery__buy-now--disabled');
          } else {
            buyNowBtn.disabled = true;
            buyNowBtn.classList.add('product-stacked-gallery__buy-now--disabled');
          }
        }
        
        // Update image if variant has featured media
        if (variant.featured_media) {
          const mediaIndex = product.media.findIndex(m => m.id === variant.featured_media.id);
          if (mediaIndex !== -1) {
            imageWrappers.forEach((img, idx) => {
              img.classList.toggle('product-stacked-gallery__image-wrapper--active', idx === mediaIndex);
            });
            
            // No thumbnail outline needed
            
            if (imageWrappers[mediaIndex]) {
              imageWrappers[mediaIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        }
      }
    }
    
    variantButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const group = btn.closest('.product-stacked-gallery__variant-group');
        if (group) {
          group.querySelectorAll('.product-stacked-gallery__variant-button').forEach(b => {
            b.classList.remove('product-stacked-gallery__variant-button--active');
          });
          btn.classList.add('product-stacked-gallery__variant-button--active');
          
          const hiddenSelect = group.querySelector(`[data-option-select="${btn.dataset.option}"]`);
          if (hiddenSelect) {
            hiddenSelect.value = btn.dataset.value;
          }
          
          updateVariant();
        }
      });
    });
    
    variantSelects.forEach(select => {
      select.addEventListener('change', () => {
        const group = select.closest('.product-stacked-gallery__variant-group');
        const correspondingSelect = group.querySelector(`[data-option-select="${select.dataset.optionSelect}"]`);
        if (correspondingSelect) {
          correspondingSelect.value = select.value;
        }
        updateVariant();
      });
    });
    
    // Quantity selector
    const quantityInput = document.getElementById('product-quantity-stacked');
    const quantityMinusBtn = section.querySelector('.product-stacked-gallery__quantity-btn--minus');
    const quantityPlusBtn = section.querySelector('.product-stacked-gallery__quantity-btn--plus');
    
    if (quantityMinusBtn && quantityInput) {
      quantityMinusBtn.addEventListener('click', function() {
        const currentValue = parseInt(quantityInput.value) || 1;
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      });
    }
    
    if (quantityPlusBtn && quantityInput) {
      quantityPlusBtn.addEventListener('click', function() {
        const currentValue = parseInt(quantityInput.value) || 1;
        quantityInput.value = currentValue + 1;
      });
    }
    
    if (quantityInput) {
      quantityInput.addEventListener('change', function() {
        const value = parseInt(this.value) || 1;
        if (value < 1) {
          this.value = 1;
        }
      });
    }
    
    // Share popup
    const shareTrigger = section.querySelector('[data-share-trigger]');
    const sharePopup = section.querySelector('[data-share-popup]');
    const copyLinkButton = section.querySelector('[data-copy-link]');
    
    if (shareTrigger && sharePopup) {
      shareTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const isOpen = sharePopup.classList.contains('product-stacked-gallery__share-popup--open');
        if (isOpen) {
          sharePopup.classList.remove('product-stacked-gallery__share-popup--open');
        } else {
          sharePopup.classList.add('product-stacked-gallery__share-popup--open');
        }
      });

      // Close popup when clicking outside
      document.addEventListener('click', function(e) {
        if (sharePopup && shareTrigger && !shareTrigger.contains(e.target) && !sharePopup.contains(e.target)) {
          sharePopup.classList.remove('product-stacked-gallery__share-popup--open');
        }
      });
    }

    // Copy link functionality
    if (copyLinkButton) {
      copyLinkButton.addEventListener('click', async function(e) {
        e.preventDefault();
        const productUrl = window.location.href;
        const button = this;
        const originalText = button.querySelector('span').textContent;
        
        try {
          await navigator.clipboard.writeText(productUrl);
          
          // Show feedback
          button.querySelector('span').textContent = 'Copied!';
          
          setTimeout(() => {
            button.querySelector('span').textContent = originalText;
          }, 2000);
        } catch (err) {
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = productUrl;
          textArea.style.position = 'fixed';
          textArea.style.opacity = '0';
          document.body.appendChild(textArea);
          textArea.select();
          
          try {
            document.execCommand('copy');
            button.querySelector('span').textContent = 'Copied!';
            setTimeout(() => {
              button.querySelector('span').textContent = originalText;
            }, 2000);
            document.body.removeChild(textArea);
          } catch (err2) {
            document.body.removeChild(textArea);
            alert('Unable to copy link. Please copy manually: ' + productUrl);
          }
        }
      });
    }

    // Wishlist button
    const wishlistButton = section.querySelector('[data-wishlist-toggle]');
    if (wishlistButton) {
      // Initialize wishlist button state
      const initWishlistButton = () => {
        if (window.wishlist) {
          window.wishlist.updateWishlistButton(wishlistButton);
        }
      };
      
      // Try to initialize immediately
      initWishlistButton();
      
      // Also try after a short delay in case wishlist loads later
      setTimeout(initWishlistButton, 100);
      
      // Listen for wishlist updates
      document.addEventListener('wishlist:updated', () => {
        initWishlistButton();
      });
      
      wishlistButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Prevent global listener from firing
        
        if (!window.wishlist) {
          console.warn('Wishlist system not loaded');
          return;
        }
        
        // Normalize productId to string to ensure consistent comparison
        const productId = String(this.dataset.productId);
        const productHandle = this.dataset.productHandle;
        
        if (!productId || !productHandle) return;
        
        // Use the toggle method from wishlist.js which handles add/remove correctly
        // This will prevent duplicate adds since isInWishlist checks first
        window.wishlist.toggle(productId, productHandle);
        
        // Button state will be updated by wishlist.js saveWishlist() which calls updateAllWishlistButtons()
      }, true); // Use capture phase to run before global listener
    }
    
    // Buy Now button
    const buyNowBtn = section.querySelector('[data-buy-now]');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const form = document.getElementById('product-form-stacked');
        const formData = new FormData(form);
        formData.append('return_to', '/checkout');
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        }).then(function(response) {
          if (!response.ok) {
            throw new Error('cart');
          }
          window.location.href = '/checkout';
        }).catch(function() {
          window.alert((window.themeStrings && window.themeStrings.addError) || '');
        });
      });
    }
    
    // Add to cart with cart drawer integration
    const form = document.getElementById('product-form-stacked');
    if (form) {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          if (response.ok) {
            // Trigger cart drawer update if available
            const event = new CustomEvent('cart:updated');
            document.dispatchEvent(event);
            
            // Show success message
            const btn = form.querySelector('.product-stacked-gallery__add-to-cart');
            const originalText = btn.querySelector('.product-stacked-gallery__add-to-cart-text').textContent;
            btn.querySelector('.product-stacked-gallery__add-to-cart-text').textContent = (window.themeStrings && window.themeStrings.added) || '';
            btn.disabled = true;
            
            setTimeout(() => {
              btn.querySelector('.product-stacked-gallery__add-to-cart-text').textContent = originalText;
              btn.disabled = false;
            }, 2000);
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
        }
      });
    }
    
    const stickyBar = section.querySelector('[data-sticky-atc]');
    const stickyButton = section.querySelector('[data-sticky-atc-button]');
    const addButton = section.querySelector('.product-stacked-gallery__add-to-cart');
    if (stickyBar && stickyButton && addButton && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          stickyBar.hidden = entry.isIntersecting;
        });
      }, { threshold: 0.2 });
      observer.observe(addButton);
      const footerGroup = document.querySelector('.shopify-section-group-footer-group');
      if (footerGroup) {
        const footerObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            stickyBar.classList.toggle('product-sticky-atc--hidden', entry.isIntersecting);
          });
        });
        footerObserver.observe(footerGroup);
      }
      stickyButton.addEventListener('click', function() {
        addButton.click();
        stickyBar.hidden = true;
      });
    }

    // Accordion Smooth Animation
    const accordions = section.querySelectorAll('[data-accordion]');
    accordions.forEach(accordion => {
      const summary = accordion.querySelector('.accordion-trigger');
      const content = accordion.querySelector('.accordion-content');
      
      if (!summary || !content) return;
      
      // Initialize: ensure closed state
      if (!accordion.hasAttribute('open')) {
        content.style.maxHeight = '0';
        content.style.paddingTop = '0';
        content.style.paddingBottom = '0';
      }
      
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        
        const isOpen = accordion.hasAttribute('open');
        
        if (isOpen) {
          // Closing: animate up
          const startHeight = content.scrollHeight;
          content.style.maxHeight = startHeight + 'px';
          content.style.paddingTop = '';
          content.style.paddingBottom = '1.5rem';
          
          // Force reflow
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              content.style.maxHeight = '0';
              content.style.paddingTop = '0';
              content.style.paddingBottom = '0';
              
              setTimeout(() => {
                accordion.removeAttribute('open');
              }, 400);
            });
          });
        } else {
          // Opening: animate down
          accordion.setAttribute('open', '');
          content.style.maxHeight = '0';
          content.style.paddingTop = '0';
          content.style.paddingBottom = '0';
          
          // Force reflow
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const endHeight = content.scrollHeight;
              content.style.maxHeight = endHeight + 'px';
              content.style.paddingTop = '';
              content.style.paddingBottom = '1.5rem';
              
              setTimeout(() => {
                content.style.maxHeight = '';
              }, 500);
            });
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('[data-video-section]');

    sections.forEach(function(section) {
      var shouldAutoplay = section.getAttribute('data-autoplay') === 'true';
      var video = section.querySelector('.product-video__video');
      var iframe = section.querySelector('[data-video-iframe]');
      var playButton = section.querySelector('[data-video-play]');
      var poster = section.querySelector('[data-video-poster]');

      function markPlaying() {
        section.classList.add('is-playing');
        if (playButton) playButton.hidden = true;
        if (poster) poster.hidden = true;
      }

      function playHosted() {
        if (!video) return;
        video.muted = true;
        video.playsInline = true;
        var pending = video.play();
        if (pending && pending.then) {
          pending.then(markPlaying).catch(function() {});
        }
      }

      function playExternal() {
        if (!iframe) return;
        if (!iframe.getAttribute('src') && iframe.getAttribute('data-src')) {
          iframe.setAttribute('src', iframe.getAttribute('data-src'));
        }
        markPlaying();
      }

      if (video) {
        video.addEventListener('playing', markPlaying);
        if (shouldAutoplay) {
          if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function(entries) {
              entries.forEach(function(entry) {
                if (entry.isIntersecting) playHosted();
                else video.pause();
              });
            }, { threshold: 0.25 });
            observer.observe(section);
          }
          playHosted();
        }
      }

      if (playButton) {
        playButton.addEventListener('click', function() {
          if (video) playHosted();
          else playExternal();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(function() {
  'use strict';
  
  const searchPage = document.querySelector('[data-search-page]');
  if (!searchPage) return;
  
  const searchInput = searchPage.querySelector('.search-page__input');
  const searchForm = searchPage.querySelector('.search-page__form');
  const clearButton = searchPage.querySelector('[data-search-clear]');
  const typeFilterInput = searchPage.querySelector('input[name="type"]');
  const filterButtons = searchPage.querySelectorAll('[data-filter-type]');
  
  // Focus search input on load if no results
  if (searchInput && !searchPage.querySelector('.search-page__results')) {
    searchInput.focus();
  }

  // Auto-submit on Enter
  if (searchInput) {
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        searchForm.submit();
      }
    });
  }
  
  // Clear search
  if (clearButton) {
    clearButton.addEventListener('click', function() {
      searchInput.value = '';
      searchInput.focus();
      if (searchForm) {
        const url = new URL(window.location.href);
        url.searchParams.delete('q');
        window.location.href = url.toString();
      }
    });
  }
  
  // Type filter buttons
  filterButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const filterType = this.getAttribute('data-filter-type');
      
      // Remove active class from all buttons
      filterButtons.forEach(function(b) {
        b.classList.remove('search-page__filter-btn--active');
      });
      
      // Add active class to clicked button
      this.classList.add('search-page__filter-btn--active');
      
      // Update hidden input
      if (typeFilterInput) {
        if (filterType === 'all') {
          typeFilterInput.remove();
        } else {
          if (!typeFilterInput.parentNode) {
            searchForm.appendChild(typeFilterInput);
          }
          typeFilterInput.value = filterType;
        }
      }
      
      // Submit form
      if (searchForm) {
        searchForm.submit();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
